import React, { useState } from 'react'
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'examples/Navbars/DashboardNavbar'
import Search from './Components/Search'
import SearchStore from './Components/SearchStore'


function SearchAndAllocatePostPaidSimStock() {
     

    const [step,setStep]=useState(1)
    const [data, setData]=useState()


   const handleStep =(input,data)=>{
      setStep(input)
      setData(data)
   }


  
 

  return (
      <>
          <DashboardLayout>
          <DashboardNavbar />
                 <div>

                  {step === 1 && <Search  getStep={handleStep}/>}
                  {step === 2 && <SearchStore getStep={handleStep}  getFormData={data}/>}

              </div>
          </DashboardLayout>
      </>
  )
}

export default SearchAndAllocatePostPaidSimStock